import initLazyLoadingImages from "./helper/lazyload-images";
import initLazyLoadingVideos from "./helper/lazyload-videos";
import vanillaJSdocumentReadyHelper from "./helper/document-ready-helper";

import { getCookie, mobileAndTabletCheck } from "./helper/helper";

(function () {
  /**
   * Add lazy loading support
   */
  initLazyLoadingImages();
  initLazyLoadingVideos();
  vanillaJSdocumentReadyHelper();

  /**
   * Hide cookiebanner if cookie is set
   */
  const bannerCookie = getCookie("cookienotice");
  const cookieBanner = document.getElementById("mb-cookiebanner");

  if (cookieBanner && bannerCookie == "true") {
    cookieBanner.style.display = "none";
  }

  /**
   * Check is mobile device
   * Use JS to fix cache issues
   */
  window.onload = function () {
    if (mobileAndTabletCheck()) {
      document.body.classList.add("mobile-browser");
      document.body.classList.remove("desktop-browser");
    } else {
      document.body.classList.remove("mobile-browser");
      document.body.classList.add("desktop-browser");
    }
  };
})();
